<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="cabinas"
        class="elevation-1"
        no-data-text="No hay datos"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Guardia v2</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-row no-gutters>
              <v-col cols="2" align-self="center">
                <v-autocomplete
                  v-model="idPerfil"
                  :items="itemsPerfiles"
                  item-text="nombre"
                  item-value="idPerfilGuardia"
                  label="Seleccionar perfil"
                  hide-details
                  clearable
                  return-object
                  @change="verNombreCartera()"
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="auto"
                align-self="center"
                class="ml-3"
                v-if="!idPerfil"
              >
                <v-btn color="primary" @click="dialogNuevoPerfil = true"
                  >Nuevo perfil</v-btn
                >
              </v-col>
              <v-col cols="auto" class="ml-3" v-if="idPerfil">
                <v-btn color="primary" @click="detallesPerfil()"
                  >Actualizar perfil</v-btn
                >
              </v-col>
              <v-col cols="auto" align-self="center" v-if="idPerfil">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" class="ml-3"
                      >Filtrar</v-btn
                    >
                  </template>
                  <v-card class="pa-2">
                    Desde:
                    <v-text-field
                      hide-details
                      dense
                      type="date"
                      v-model="fechaInicio"
                    ></v-text-field>
                    Hasta:
                    <v-text-field
                      hide-details
                      dense
                      type="date"
                      v-model="fechaFin"
                    ></v-text-field>
                    <v-card-actions class="pb-0 pr-0">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="listarCabina()"
                        >Listar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="seleccionarCampos()"
                v-if="cabinas.length > 0 && idPerfil.nombre != undefined"
                >Descargar</v-btn
              >
            </v-row>
          </v-toolbar>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogNuevoPerfil" max-width="800" persistent>
        <v-card>
          <v-card-title
            >Perfil
            <v-spacer></v-spacer>
            <v-btn class="mr-3" outlined @click="cerrarDialog()">Cerrar</v-btn>
            <v-btn
              v-if="bandera != 0"
              color="primary"
              @click="actualizarPerfil()"
              >Actualizar</v-btn
            >
            <v-btn v-if="bandera == 0" color="primary" @click="guardarPerfil()"
              >Guardar</v-btn
            >
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6" class="mx-auto">
                <v-text-field
                  v-model="nombrePerfil"
                  label="Nombre del perfil"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="mx-auto">
                <v-autocomplete
                  v-model="nombreCartera"
                  :items="itemsCartera"
                  label="Cartera"
                  hint="Si deja este campo vacío descargará la información de todas las carteras"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="auto"
                v-for="(selection, i) in selections"
                :key="selection.text"
              >
                <v-chip
                  close
                  @click:close="selectedRemovido(i, selection)"
                  :value="selection.idCampoCabina"
                >
                  {{ selection.nombrePersonalizado }}
                </v-chip>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  ref="search"
                  v-model="search"
                  hide-details
                  label="Buscar"
                  single-line
                >
                </v-text-field>
              </v-col>
              <v-col>
                <v-list>
                  <template v-for="item in filtro">
                    <v-list-item :key="item.text" @click="selected.push(item)">
                      <v-list-item-avatar>
                        <v-icon>fas fa-circle</v-icon>
                      </v-list-item-avatar>
                      <v-list-item-title>{{
                        item.nombrePersonalizado
                      }}</v-list-item-title>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- PreLoader -->
      <v-overlay v-model="overlay" z-index="0">
        <lottie-player
          v-if="true"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          background="transparent"
          speed="1"
          style="width: 300px; height: 300px"
          loop
          autoplay
        ></lottie-player>
      </v-overlay>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
var moment = require("moment");
import settings from "../settings/index";

export default {
  data() {
    return {
      search: "",
      cabinas: [],
      itemsPerfiles: [],
      itemsCamposCabina: [],
      itemsCartera: [],
      headers: [
        {
          text: "Numero Asistencia",
          value: "numeroAsistencia",
          sortable: true,
        },
        { text: "Cartera", value: "cartera", sortable: true },
        { text: "Fecha Actual", value: "fechaHoraActual", sortable: true },
        { text: "Placa", value: "placa", sortable: true },
        { text: "Poliza", value: "polizaBase", sortable: true },
        { text: "Marca", value: "marcaBase", sortable: true },
        { text: "Modelo", value: "modeloBase", sortable: true },
        { text: "Año", value: "añoBase", sortable: true },
        { text: "Titular Poliza", value: "titularPolizaBase", sortable: true },
      ],
      nombreCartera: "",
      fechaInicio: "",
      fechaFin: "",
      overlay: false,
      idPerfil: "",
      camposCabina: [],
      dialogNuevoPerfil: false,
      nombrePerfil: "",
      selected: [],
      bandera: 0,
      final: [],
      removidos: [],
      nombresSeleccionados: [],
      menu: false,
    };
  },
  computed: {
    filtro() {
      const search = this.search.toLowerCase();

      if (!search) return this.itemsCamposCabina;

      return this.itemsCamposCabina.filter((item) => {
        const text = item.nombrePersonalizado.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(selection);
      }

      return selections;
    },
  },
  watch: {
    selected() {
      this.search = "";
    },
  },
  created() {
    this.listarCarteras();
    this.listarCamposCabina();
    this.listarPerfiles();
  },
  methods: {
    listarCarteras() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Carteras/Activas", configuracion)
        .then((res) => (this.itemsCartera = res.data))
        .catch((err) => console.error(err.response));
    },
    listarCabina() {
      if (this.fechaInicio && this.fechaFin) {
        var url = "";
        if (!this.nombreCartera) {
          url =
            "api/Cabinas/ListarxGuardia/" +
            this.fechaInicio +
            "/" +
            this.fechaFin;
        } else {
          url =
            "api/Cabinas/ListarxCartera/" +
            this.fechaInicio +
            "/" +
            this.fechaFin +
            "/" +
            this.nombreCartera;
        }
        let header = { Authorization: "Bearer " + this.$store.state.token };
        let configuracion = { headers: header };
        axios
          .get(url, configuracion)
          .then((response) => {
            this.cabinas = response.data;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    listarCamposCabina() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/CamposCabina/Listar", configuracion)
        .then((response) => {
          this.itemsCamposCabina = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listarPerfiles() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Perfiles/Listar", configuracion)
        .then((response) => {
          this.itemsPerfiles = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    verNombreCartera() {
      if (this.idPerfil) {
        this.nombreCartera = this.idPerfil.cartera;
      } else {
        this.nombreCartera = "";
      }
    },
    guardarPerfil() {
      //primero se guardara el perfil y automaticamente se guardaran los campos
      var array = [];
      this.selections.forEach((element) => {
        array.push({
          idCampoCabina: element.idCampoCabina,
          idUsuario: this.$store.state.usuario.idUsuario,
        });
      });

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .post(
          "api/Perfiles/Crear",
          {
            nombre: this.nombrePerfil,
            cartera: this.nombreCartera,
            cabinaxPerfil: array,
          },
          configuracion
        )
        .then(() => {
          this.dialogNuevoPerfil = false;
          this.limpiar();
          this.listarPerfiles();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    detallesPerfil() {
      this.bandera = 1;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/CabinaxPerfiles/Listar/" + this.idPerfil.idPerfilGuardia,
          configuracion
        )
        .then((response) => {
          this.nombrePerfil = this.idPerfil.nombre;
          this.nombreCartera = response.data[0].nombreCartera;
          response.data.forEach((element) => {
            this.selections.push(element);
            this.selected.push(element);
          });
          this.dialogNuevoPerfil = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    actualizarPerfil() {
      //para actualizar primero se actualizar el perfil, luego se eliminaran los camposxPerfiles y volver a crearlos
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/Perfiles/Actualizar",
          {
            idPerfilGuardia: this.idPerfil.idPerfilGuardia,
            nombre: this.nombrePerfil,
            cartera: this.nombreCartera,
          },
          configuracion
        )
        .then(() => {
          this.eliminarCabinaxPerfil();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    eliminarCabinaxPerfil() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      this.selected.forEach(async (element) => {
        if (!element.idCabinaxPefil) {
          await axios
            .post(
              "api/CabinaxPerfiles/Crear",
              {
                idCampoCabina: element.idCampoCabina,
                idPerfilGuardia: this.idPerfil.idPerfilGuardia,
                idUsuario: this.$store.state.usuario.idUsuario,
              },
              configuracion
            )
            .catch((error) => {
              console.log(error);
            });
        }
      });

      this.removidos.forEach(async (element) => {
        if (element.idCabinaxPefil) {
          await axios
            .delete(
              "api/CabinaxPerfiles/Eliminar/" + element.idCabinaxPefil,
              configuracion
            )
            .catch((error) => {
              console.log(error);
            });
        }
      });
      this.cerrarDialog();
    },
    selectedRemovido(i, item) {
      this.selected.splice(i, 1);
      this.removidos.push(item);
    },
    cerrarDialog() {
      this.dialogNuevoPerfil = false;
      this.bandera = 0;
      this.limpiar();
    },
    limpiar() {
      this.camposCabina = [];
      this.nombrePerfil = "";
      this.nombreCartera = "";
      this.selected = [];
      this.removidos = [];
    },
    async seleccionarCampos() {
      this.nombresSeleccionados = [];
      this.final = [];

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      await axios
        .get(
          "api/CabinaxPerfiles/Listar/" + this.idPerfil.idPerfilGuardia,
          configuracion
        )
        .then((response) => {
          this.nombresSeleccionados = response.data;
        })
        .catch((error) => {
          console.log(error);
        });

      for (var i = 0; i < this.nombresSeleccionados.length; i++) {
        this.extractValue(
          this.cabinas,
          this.nombresSeleccionados[i].nombreBase,
          this.nombresSeleccionados[i].nombrePersonalizado,
          this.nombresSeleccionados[i].tipoDato
        );
      }

      this.excel();
    },
    extractValue(arr, prop, propP, propTipoDato) {
      arr.map((item, index) => {
        if (this.final[index] != undefined) {
          this.formatoCampos(propTipoDato, index, propP, prop, item);
        } else {
          this.formatoCamposUndefined(propTipoDato, propP, prop, item);
        }
      });
    },
    formatoCampos(propTipoDato, index, propP, prop, item) {
      if (propTipoDato == "string") {
        this.final[index][propP] = item[prop];
      } else if (propTipoDato == "dateTime") {
        this.final[index]["FECHA " + propP.split(" ").splice(-1)[0]] =
          this.formatoFecha(item[prop]);
        this.final[index]["HORA " + propP.split(" ").splice(-1)[0]] =
          this.formatoHora(item[prop]);
      } else if (propTipoDato == "int") {
        this.final[index][propP] = item[prop];
      } else if (propTipoDato == "bool") {
        if (item[prop]) {
          this.final[index][propP] = "SI";
        } else {
          this.final[index][propP] = "NO";
        }
      }
    },
    formatoCamposUndefined(propTipoDato, propP, prop, item) {
      if (propTipoDato == "string") {
        this.final.push({
          [propP]: item[prop],
        });
      } else if (propTipoDato == "dateTime") {
        this.final.push({
          ["FECHA " + propP.split(" ").splice(-1)[0]]: this.formatoFecha(
            item[prop]
          ),
          ["HORA " + propP.split(" ").splice(-1)[0]]: this.formatoHora(
            item[prop]
          ),
        });
      } else if (propTipoDato == "int") {
        this.final.push({
          [propP]: item[prop],
        });
      } else if (propTipoDato == "bool") {
        if (item[prop]) {
          this.final.push({
            [prop]: "SI",
          });
        } else {
          this.final.push({
            [prop]: "NO",
          });
        }
      }
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD");
    },
    formatoHora(fecha) {
      return moment(fecha).format("HH:mm:ss");
    },
    excel() {
      let data = XLSX.utils.json_to_sheet(this.final);
      const workbook = XLSX.utils.book_new();
      const filename = "Guardia " + this.idPerfil.nombre;
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
};
</script>
